var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { buildChartSeries, deriveReportCategory, EXCLUDED_REPORT_IDS, INITIAL_CATEGORIES, INITIAL_DOWN_DATA, reportSortPriority, } from "../constants/customReportPage.constants";
import { buildProductsData } from "../../reportsPage/reportsMetrics";
import { useApiPostReports } from "../../../fnx/reports/postReports";
import { showErrorToast } from "../../../fnx/showError";
import { quoteAll, quoteAllClearData, } from "../../../store/generateQuote/actions";
import { reportsClearData } from "../../../store/reports/actions";
import { getCurrentMonth, getCurrentSemester, getPreviousMonth, getQuarterDates, } from "../../../services/getDates";
import { formattedDateWithTime, formattedDateYYMMDD, } from "../../../utils/date";
import { getQuoteList } from "../../../utils/normalizeQuoteResponse";
import { findParamInLocalStorage } from "ah_utility/fnxUtils";
var QUOTE_PARAMS = { enable: true, page: 1, limit: 10000 };
export var useCustomReportPage = function () {
    var t = useTranslation().t;
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var clientId = useMemo(function () { var _a; return (_a = findParamInLocalStorage("clientId", "assurehub")) !== null && _a !== void 0 ? _a : ""; }, []);
    var _a = useState({
        enable: QUOTE_PARAMS.enable,
        page: QUOTE_PARAMS.page,
        limit: QUOTE_PARAMS.limit,
        reportCard: [],
        reportTrigger: false,
        // Sin paginador en el panel: se piden todos los reportes de una vez.
        bodyReport: { fkClientId: clientId, page: 1, pageSize: 1000 },
        dateRange: "",
        totalItems: 0,
    }), state = _a[0], setState = _a[1];
    var _b = useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), toast = _b[0], setToast = _b[1];
    var _c = useState(INITIAL_DOWN_DATA), newDownData = _c[0], setNewDownData = _c[1];
    var _d = useState(buildChartSeries(t)), dataSeries = _d[0], setDataSeries = _d[1];
    var _e = useState(INITIAL_CATEGORIES), dataCategories = _e[0], setDataCategories = _e[1];
    var _f = useState([]), productsData = _f[0], setProductsData = _f[1];
    var _g = useApiPostReports(state.reportTrigger, state.bodyReport, function () { return setState(function (prev) { return (__assign(__assign({}, prev), { reportTrigger: false })); }); }), loadingReports = _g.loadingReports, responseReports = _g.responseReports, errorReports = _g.errorReports;
    var _h = useSelector(function (storeState) { return ({
        responseAllQuote: storeState.Quote.responseAllQuote,
        errorAllQuote: storeState.Quote.errorAllQuote,
        loadingAllQuote: storeState.Quote.loadingAllQuote,
    }); }), responseAllQuote = _h.responseAllQuote, errorAllQuote = _h.errorAllQuote, loadingAllQuote = _h.loadingAllQuote;
    var callQuoteAll = useCallback(function (date1, date2) {
        dispatch(quoteAll({
            enable: QUOTE_PARAMS.enable,
            creationDateStart: date1,
            creationDateEnd: date2,
            page: QUOTE_PARAMS.page,
            limit: QUOTE_PARAMS.limit,
        }));
    }, [dispatch]);
    var updateChartData = useCallback(function (quoteList) {
        var emitidas = quoteList.filter(function (item) { var _a; return ((_a = item.catalogStatusQuote) === null || _a === void 0 ? void 0 : _a.description) === "Emitida"; });
        var cotizadas = quoteList.filter(function (item) { var _a; return ((_a = item.catalogStatusQuote) === null || _a === void 0 ? void 0 : _a.description) === "Cotizada"; });
        var canceladas = quoteList.filter(function (item) { var _a; return ((_a = item.catalogStatusQuote) === null || _a === void 0 ? void 0 : _a.description) === "Cancelada"; });
        setNewDownData(function (prev) {
            return prev.map(function (card) {
                if (card.id === "1")
                    return __assign(__assign({}, card), { numericalTitle: emitidas.length.toString() });
                if (card.id === "2")
                    return __assign(__assign({}, card), { numericalTitle: cotizadas.length.toString() });
                if (card.id === "3")
                    return __assign(__assign({}, card), { numericalTitle: canceladas.length.toString() });
                return card;
            });
        });
        var productCount = {};
        quoteList.forEach(function (item) {
            var _a, _b, _c;
            var productId = (_a = item === null || item === void 0 ? void 0 : item.productId) === null || _a === void 0 ? void 0 : _a.id;
            var description = (_b = item === null || item === void 0 ? void 0 : item.productId) === null || _b === void 0 ? void 0 : _b.description;
            var status = (_c = item === null || item === void 0 ? void 0 : item.catalogStatusQuote) === null || _c === void 0 ? void 0 : _c.description;
            if (!productCount[productId]) {
                productCount[productId] = { description: description, countsByStatus: {} };
            }
            productCount[productId].countsByStatus[status] =
                (productCount[productId].countsByStatus[status] || 0) + 1;
        });
        var top5 = Object.keys(productCount)
            .map(function (key) {
            var product = productCount[key];
            var totalCount = Object.values(product.countsByStatus).reduce(function (sum, count) { return sum + count; }, 0);
            return __assign(__assign({}, product), { id: key, totalCount: totalCount });
        })
            .sort(function (a, b) { return b.totalCount - a.totalCount; })
            .slice(0, 5);
        setDataSeries(function (prev) { return [
            __assign(__assign({}, prev[0]), { data: top5.map(function (p) { return p.countsByStatus["Emitida"] || 0; }) }),
            __assign(__assign({}, prev[1]), { data: top5.map(function (p) { return p.countsByStatus["Cotizada"] || 0; }) }),
        ]; });
        setDataCategories(top5.map(function (p) { return p.description; }));
        // Alimenta las tarjetas por producto de V2 (barras, dona y embudo).
        setProductsData(buildProductsData(quoteList));
    }, []);
    useEffect(function () {
        setState(function (prev) { return (__assign(__assign({}, prev), { reportTrigger: true })); });
        var _a = getCurrentMonth(), startDate = _a.startDate, endDate = _a.endDate;
        callQuoteAll(startDate, endDate);
        setState(function (prev) { return (__assign(__assign({}, prev), { dateRange: "currentMonth" })); });
    }, []);
    useEffect(function () {
        if (errorReports) {
            showErrorToast(errorReports, setToast, t);
            setState(function (prev) { return (__assign(__assign({}, prev), { reportTrigger: false })); });
            dispatch(reportsClearData());
        }
    }, [errorReports]);
    useEffect(function () {
        if (errorAllQuote) {
            showErrorToast(errorAllQuote, setToast, t);
            dispatch(quoteAllClearData());
        }
    }, [errorAllQuote]);
    useEffect(function () {
        var _a;
        if (responseReports) {
            var data_1 = (_a = responseReports === null || responseReports === void 0 ? void 0 : responseReports.data) === null || _a === void 0 ? void 0 : _a.filter(function (item) { return !EXCLUDED_REPORT_IDS.includes(item.id); }).map(function (item) {
                var _a;
                return ({
                    id: item.id,
                    title: item.name,
                    subTitle: "Por Rango de fechas",
                    renderHtml: (_a = item.renders_html) !== null && _a !== void 0 ? _a : false,
                    type: deriveReportCategory(item.name),
                });
            }).sort(function (a, b) {
                var _a, _b;
                return reportSortPriority((_a = a.title) !== null && _a !== void 0 ? _a : "") -
                    reportSortPriority((_b = b.title) !== null && _b !== void 0 ? _b : "");
            });
            setState(function (prev) {
                var _a, _b;
                return (__assign(__assign({}, prev), { reportCard: data_1, totalItems: (_b = (_a = responseReports === null || responseReports === void 0 ? void 0 : responseReports.pageInfo) === null || _a === void 0 ? void 0 : _a.totalItems) !== null && _b !== void 0 ? _b : 0 }));
            });
            dispatch(reportsClearData());
        }
    }, [responseReports]);
    useEffect(function () {
        var quoteList = getQuoteList(responseAllQuote);
        if (quoteList.length > 0) {
            updateChartData(quoteList);
            dispatch(quoteAllClearData());
        }
    }, [responseAllQuote]);
    var onClickMonthReport = function (item) {
        var _a;
        var dateMap = {
            currentMonth: getCurrentMonth,
            prevMonth: getPreviousMonth,
            currentQuarter: function () { return getQuarterDates("current"); },
            prevQuarter: function () { return getQuarterDates("previous"); },
            currentSemester: getCurrentSemester,
        };
        var rangeFn = dateMap[(_a = item.code) !== null && _a !== void 0 ? _a : ""];
        if (!rangeFn)
            return;
        var _b = rangeFn(), startDate = _b.startDate, endDate = _b.endDate;
        callQuoteAll(startDate, endDate);
        setState(function (prev) { var _a; return (__assign(__assign({}, prev), { dateRange: (_a = item.code) !== null && _a !== void 0 ? _a : "" })); });
    };
    var openReport = function (action, item) {
        var _a;
        if (action.id === "1") {
            var renderHtml = (_a = item.renderHtml) !== null && _a !== void 0 ? _a : false;
            navigate("/reports-summaries/".concat(item.id, "/").concat(state.dateRange), {
                state: { reportName: item.title, renderHtml: renderHtml },
            });
        }
    };
    var filterCalendar = function (dates) {
        var _a, _b;
        var resolve = function (val) {
            var formatted = formattedDateWithTime(val);
            return ["undefined", "null", "NA"].includes(formatted) ? "" : formatted;
        };
        var startDate = resolve((_a = dates === null || dates === void 0 ? void 0 : dates.dateRange) === null || _a === void 0 ? void 0 : _a.startDate);
        var endDate = resolve((_b = dates === null || dates === void 0 ? void 0 : dates.dateRange) === null || _b === void 0 ? void 0 : _b.endDate);
        if (startDate && endDate) {
            setState(function (prev) { return (__assign(__assign({}, prev), { dateRange: "".concat(formattedDateYYMMDD(startDate), "---").concat(formattedDateYYMMDD(endDate)) })); });
        }
        callQuoteAll(startDate, endDate);
    };
    var clearCalendar = function () {
        var _a = getCurrentMonth(), startDate = _a.startDate, endDate = _a.endDate;
        callQuoteAll(startDate, endDate);
    };
    var onChangePage = function (newPage) {
        setState(function (prev) { return (__assign(__assign({}, prev), { reportTrigger: true, bodyReport: __assign(__assign({}, prev.bodyReport), { page: newPage }) })); });
    };
    var onChangeRowsPerPage = function (newPageSize) {
        setState(function (prev) { return (__assign(__assign({}, prev), { reportTrigger: true, bodyReport: __assign(__assign({}, prev.bodyReport), { page: 1, pageSize: newPageSize }) })); });
    };
    return {
        loading: loadingReports || loadingAllQuote,
        toast: toast,
        setToast: setToast,
        reportCard: state.reportCard,
        newDownData: newDownData,
        dataSeries: dataSeries,
        dataCategories: dataCategories,
        productsData: productsData,
        totalItems: state.totalItems,
        currentPage: state.bodyReport.page,
        currentPageSize: state.bodyReport.pageSize,
        onClickMonthReport: onClickMonthReport,
        openReport: openReport,
        filterCalendar: filterCalendar,
        clearCalendar: clearCalendar,
        onChangePage: onChangePage,
        onChangeRowsPerPage: onChangeRowsPerPage,
    };
};
